<template>
    <div>
        <el-dialog
            :title="dialogFormTitle"
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            width="30%"
            :center="true"
            top="20vh"
            :close-on-click-modal="false"
            :before-close="() => closeEnterpriseDialog('enterpriseEditForm')"
            v-loading.fullscreen.lock="login_loading"
        >
            <div>
                <el-form
                    :model="enterprise"
                    :rules="rules"
                    ref="enterpriseEditForm"
                    label-width="100px"
                    size="small"
                >
                    <div v-if="show_type">
                        <el-form-item label="企业名称" prop="name">
                            <el-input
                                v-model="enterprise.name"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item v-if="this.id" label="负责人" prop="name">
                            <el-select
                                v-model="enterprise.director"
                                filterable
                                placeholder="请选择负责人"
                                class="directorc"
                            >
                                <el-option
                                    v-for="item in options"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div v-else>
                        <el-descriptions
                            class="margin-top"
                            :column="1"
                            :labelStyle="{'width':'120px','text-align':'center'}"
                            :contentStyle="{'text-align': 'center'}"
                            border
                        >
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>企业名称</span>
                                </template>
                                <span>{{enterprise.name}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>负责人</span>
                                </template>
                                <span>{{enterprise.director_name}}</span>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <div v-if="show_type===0">
                    <el-button
                        v-if="$_has(edit_auth)"
                        type="primary"
                        plain
                        @click="$emit('show_edit')"
                        >修改</el-button
                    >
                    <el-button
                        v-if="$_has(del_auth)"
                        type="danger"
                        plain
                        @click="enterpriseDel('enterpriseEditForm')"
                        >删除</el-button
                    >
                    <el-button
                        plain
                        @click="closeEnterpriseDialog('enterpriseEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else-if="show_type===1">
                    <el-button
                        type="success"
                        plain
                        @click="submitInsert('enterpriseEditForm')"
                        >确定</el-button
                    >
                    <el-button
                        type="warning"
                        plain
                        @click="resetForm('enterpriseEditForm')"
                        >重置</el-button
                    >
                    <el-button
                        plain
                        @click="closeEnterpriseDialog('enterpriseEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else>
                    <el-button
                        type="success"
                        plain
                        @click="submitEdit('enterpriseEditForm')"
                        >确定修改</el-button
                    >
                    <el-button
                        plain
                        @click="closeEnterpriseDialog('enterpriseEditForm')"
                        >取消操作</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { enterprise_add_request,enterprise_del_request,enterprise_edit_request } from '@/network/enterprise.js'

export default {
    name: 'EnterpriseEditComponent',
    data() {
        return {
            login_loading: false,
            enterprise: {
                name: '',
                director: '',
                director_name: ''
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入企业名称',
                        trigger: 'blur',
                    },
                    {
                        min: 2,
                        max: 16,
                        message: '长度在 2 到 8 个字符',
                        trigger: 'blur',
                    },
                ],
            },
            options: [],
        }
    },
    computed: {
        dialogFormTitle() {
            if(this.show_type === 0) {
                return '企业详情'
            } else if (this.show_type === 1) {
                return '添加企业'
            } else {
                return '修改企业'
            }
        },
    },
    methods: {
        closeEnterpriseDialog(formName) {
            this.enterprise = {
                name: '',
                director: '',
                director_name: ''
            }
            this.$emit('exitEnterpriseDialog')
        },
        submitInsert(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.enterpriseInsert(formName)
            })
        },
        enterpriseInsert(formName) {
            this.login_loading = true
            enterprise_add_request(this.enterprise)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('添加成功!')
                        this.$emit('exitEnterpriseDialog')
                        this.$emit('search')
                        this.$emit('details_row',s.result.id*1)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
        },
        submitEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.enterpriseEdit(formName)
            })
        },
        enterpriseEdit(formName) {
            this.login_loading = true
            this.enterprise.id = this.id
            enterprise_edit_request(this.enterprise)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('修改成功!')
                        this.$emit('exitEnterpriseDialog')
                        this.$emit('search')
                        this.$emit('details_row',this.enterprise.id)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        enterpriseDel(formName) {
            this.$confirm(
                '是否确定删除？（一经删除，将无法再进行恢复，请谨慎操作！）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    enterprise_del_request(this.id)
                        .then((s) => {
                            if (s.status === 0) {
                                this.$message.success('删除成功!')
                                this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.$message.error(err)
                        })
                        .finally(() => this.closeEnterpriseDialog(formName))
                })
                .catch((err) => {})
        },
    },
    filters: {},
    props: {
        dialogFormVisible: Boolean,
        id: {
            type: Number,
            default() {
                return 0
            },
        },
        enterprise_details_data: {
            type: Object,
            default() {
                return {}
            },
        },
        foptions: {
            type: Array,
            default() {
                return []
            },
        },
        show_type: {
            type:Number,
            default() {
                return 0
            },
        },
        edit_auth: String,
        del_auth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {
        enterprise_details_data(newVal) {
            this.enterprise = newVal
        },
        foptions(newVal) {
            this.options = newVal
        },
    },
}
</script>

<style>
</style>